import { FC, useCallback, useState } from 'react';
import cn from 'clsx';
import { format } from 'date-fns';

import { InputTextProps } from '../InputText';

import Modal from './Modal';

interface DatePickerProps extends Omit<InputTextProps, 'onChange' | 'value'> {
  onChange?: (value: Date) => void;
  title?: string;
  value?: Date;
  dateFormat?: string;
}

const DatePicker: FC<any> = ({
  onChange,
  disabled,
  title,
  neon,
  children,
  value: propValue,
  dateFormat,
  className,
  ...inputProps
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [value, setValue] = useState<Date>();
  const displayValue = propValue === undefined ? value : propValue;
  const showModal = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const hideModal = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const _onChange = useCallback(
    (date: Date) => {
      if (propValue === undefined) setValue(date);
      onChange?.(date);
      hideModal();
    },
    [onChange, propValue, setValue, hideModal]
  );

  return (
    <>
      <div
        role="button"
        className={cn(
          'cursor-pointer',
          {
            'cursor-not-allowed': disabled,
          },
          className
        )}
        onClick={disabled ? undefined : showModal}
      >
        {children || (
          <input
            className={
              neon
                ? cn(
                    'w-full px-4 py-4 bg-transparent  pointer-events-none text-white ',
                    {
                      'text-gray-dark shadow-r-gray-dark-sm': disabled,
                    }
                  )
                : cn(
                    'w-full px-4 py-4 bg-white border-2 border-white rounded-md pointer-events-none text-purple ',
                    {
                      'shadow-r-magenta-sm': !disabled,
                      'text-gray-dark shadow-r-gray-dark-sm': disabled,
                    }
                  )
            }
            style={neon ? { borderBottom: `solid 2px ${neon}` } : {}}
            value={displayValue ? format(displayValue, 'h:mm a') : ''}
            readOnly
            disabled={disabled}
            {...inputProps}
          />
        )}
      </div>
      <Modal
        title={title}
        open={open}
        onClose={hideModal}
        onSelect={_onChange}
        value={displayValue}
        dateFormat={dateFormat}
      />
    </>
  );
};

export default DatePicker;
